import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseOutboundModesAdapter = getAdapter({ idFieldName: 'value' });

const warehouseOutboundModesSlice = createSlice({
  name: 'warehouseOutboundModes',
  initialState: warehouseOutboundModesAdapter.getInitialState(),
  reducers: {
    setWarehouseOutboundModes: (state, { payload: { outboundModes } }) => {
      warehouseOutboundModesAdapter.setAll(state, outboundModes);
    },
  },
});

const selectors = warehouseOutboundModesAdapter.getSelectors(({ warehouseOutboundModes }) => warehouseOutboundModes);

export const getWarehouseOutboundModesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseOutboundModes = (state) => getWarehouseOutboundModesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseOutboundModes,
} = warehouseOutboundModesSlice.actions;

export default warehouseOutboundModesSlice.reducer;
